export const BLOCK_PLACES = {
  recipePage: 'recipe-page',
  articlePage: 'article-page',
  mainContentArea: 'main-content-area',
  relatedContentArea: 'related-content-area',
  accordion: 'accordion',
};

export const MEDIA_ORIENTATIONS = {
  landscape: 'landscape',
  portrait: 'portrait',
  responsive: 'responsive',
};
